<template>
  <div>
    <el-card class="box-card">
      <el-row :gutter="35">
        <el-form :model="form" ref="form" inline label-width="auto" size="small" :rules="{}">
          <el-row>
            <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
              <range-date-picker ref="datePick" @showDateTime="handleShowDateTime" />
            </el-form-item>
            <el-form-item :label="$t('orders.label.table.payoutTime')">
              <range-date-picker
                :need-init="false"
                ref="payOutDatePick"
                @showDateTime="handleShowPayOutTime"
              />
            </el-form-item>
          </el-row>
          <el-form-item :label="$t('orders.label.form.merchatNo')">
            <el-input v-model="form.query.merchantNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wallet.label.merchatOrderNo')">
            <el-input v-model="form.query.orderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orders.label.form.systemOrderNo')">
            <el-input v-model="form.query.systemOrderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.paymentBank')">
           <el-input v-model="form.query.accountBankCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.paymentName')" prop="accountName">
            <el-input v-model="form.query.accountName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.paymentAccount')">
           <el-input v-model="form.query.accountNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orders.label.table.orderStatus')">
            <el-select v-model="form.query.orderStatus">
              <el-option
                v-for="key in Object.keys(orderStatusCode)"
                :label="orderStatusCode[key]"
                :key="key"
                :value="key"
              ></el-option>
              <el-option :label="$t('btns.emptyValue')" value=""></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.asyncStatus.label')">
            <el-select v-model="form.query.syncStatus">
              <el-option
                v-for="key in Object.keys(notify.status)"
                :key="key"
                :value="key"
                :label="notify.status[key]"
              ></el-option>
              <el-option :label="$t('btns.emptyValue')" value=""></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.channelType')">
            <el-select v-model="form.query.tripleChannelType" clearable>
              <el-option
                v-for="item in channelTypeArray"
                :key="item"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.paymentType')">
            <el-select v-model="form.query.paymentType" clearable>
              <el-option
                v-for="item in paymentType"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :inline="true" :label="$t('orders.label.form.amountStart')">
            <div style="display: flex">
              <el-input size="mini" v-model.trim="form.query.amountStart" clearable></el-input>
              <span>-</span>
              <el-input size="mini" v-model.trim="form.query.amountEnd" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item style="margin-left: 20px">
            <el-button size="mini" type="primary" @click="handleEmpty()">{{
              $t('btns.empty')
            }}</el-button>
            <el-button size="mini" type="primary" @click="handleSearch()" :loading="searchLoading"
              >{{ $t('btns.search') }}
            </el-button>
            <el-button size="mini" type="success" @click="allOlder()">{{
          $t('btns.allOlder')
        }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row style="margin-bottom: 20px">
        <el-col :span="16" :offset="15">
          <div>
            <el-switch
              v-if="true"
              v-model="refresh"
              @change="refTableData"
              :active-text="$t('btns.start1')"
              :inactive-text="$t('btns.stop1')"
            >
          </el-switch>
          <el-button
            v-if="tableData.length && permission.indexOf('orderRecord:payout:export') > -1"
            @click="handleExport()"
          >
            {{ $t('btns.export') }}
          </el-button>
          </div>
        </el-col> 
      </el-row>
      <el-row>
        <div class="header-table">
          <ul class="list-table">
            <li class="li-table">
              <em class="label">
                <span>{{ $t('withdraw.label.payoutAmountCount') }}</span>
                <span>：</span>
              </em>
              <span class="value">{{ payoutCountInfo.paymentAmountTotal | toThousands }}</span>
            </li>
            <li class="li-table">
              <em class="label">
                <span>{{ $t('withdraw.label.payoutFeeCount') }}</span>
                <span>：</span>
              </em>
              <span class="value">{{ payoutCountInfo.handlingFeeTatal | toThousands }}</span>
            </li>
            <li class="li-table">
                <em class="label">
                  <span>{{ $t('withdraw.label.paymentFixedFeeTatal') }}</span>
                  <span>：</span>
                </em>
                <span class="value">{{ payoutCountInfo.paymentFixedHandlingFeeTatal | toThousands }}</span>
            </li>
            <li class="li-table">
                <em class="label">
                  <span>{{ $t('withdraw.label.autoSuccessAmount') }}</span>
                  <span>：</span>
                </em>
                <span class="value">{{ payoutCountInfo.autoSuccessAmount | toThousands }}</span>
            </li>
            <li class="li-table">
                <em class="label">
                  <span>{{ $t('withdraw.label.manualSuccessAmount') }}</span>
                  <span>：</span>
                </em>
                <span class="value">{{ payoutCountInfo.manualSuccessAmount | toThousands }}</span>
            </li>
          </ul>
        </div>
        
        <el-table
          :data="tableData"
          v-loading="tableLoading"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ textAlign: 'center' }"
          :row-class-name="tableRowClassName"
           :row-key="rowKey"
           @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
          <el-table-column type="index" label="#"></el-table-column>
          <el-table-column
            class-name="status-omit-colum"
            width="120px"
            prop="systemOrderNo"
            :label="$t('orders.label.table.systemOrderNo')"
            >
            <template slot-scope="{ row }">
              <i
                :title="$t('onlinememberdrawal.copy')"
                class="fa fa-clipboard"
                style="color: #777; cursor: pointer"
                @click="copyText(row.systemOrderNo)"
              ></i>
              <router-link
                v-if="userType === 0"
                :to="{ name: 'transactionRecord', query: { systemOrderNo: row.systemOrderNo } }"
              >
                {{ row.systemOrderNo }}
              </router-link>
              <span v-else>
                {{ row.systemOrderNo }}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('clientmanage.table.merchantNo')"  prop="merchantNo"/>
           <el-table-column :label="$t('withdraw.label.merchatName')" prop="attribute2"/>
          <el-table-column :label="$t('wallet.label.merchatOrderNo')" prop="orderNo" class-name="status-omit-colum"  width="120px">
            <template slot-scope="{ row }">
              <i
                :title="$t('onlinememberdrawal.copy')"
                class="fa fa-clipboard"
                style="color: #777; cursor: pointer"
                @click="copyText(row.orderNo)"
              ></i>
              <span>{{ row.orderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('withdraw.label.bankCode')" prop="bankCode"></el-table-column>
          <el-table-column :label="$t('withdraw.label.bankNo')" prop="cardNumber"></el-table-column>
          <el-table-column
            :label="$t('withdraw.label.receiver')"
            prop="beneficiaryName"
          ></el-table-column>

          <el-table-column
            :label="$t('withdraw.label.paymentAccount')"
            prop="accountNumber"
            v-if="!info.userType"
          ></el-table-column>
          <el-table-column :label="$t('channelTest.label.amount')" prop="amount">
            <template slot-scope="{ row }">
              {{ row.amount | toThousands }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('withdraw.label.handlingFee')" prop="fee">
            <template slot-scope="{ row }">
              {{ row.fee | toThousands }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('clientmanage.updataDia.payoutFixedFee')" prop="payoutFixedFee">
            <template slot-scope="{ row }">
              {{ row.payoutFixedFee | toThousands }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('orders.label.table.orderStatus')" prop="orderStatus">
            <template slot-scope="{ row }">
              <span>{{ orderStatusCode[row.orderStatus] }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('withdraw.label.asyncStatus.label')" prop="syncStatus">
            <template slot-scope="{ row }">
              <span>{{ notify.status[row.syncStatus] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            :label="$t('withdraw.label.paymentType')"
            width="120px"
            v-if="permission.indexOf('merchant:payout:auto') != -1 && !info.userType"
          >
            <template slot-scope="{ row }">
              <el-button
                type="warning"
                size="mini"
                v-if="[1, 2, 88, 6].indexOf(row.orderStatus) == -1"
                @click="requestAutoPayOut(row.systemOrderNo)"
              >
                {{ $t('orders.label.table.autoPayout') }}
              </el-button>
              <el-button
                type="warning"
                size="mini"
                v-if="row.type == 1"
              >
                {{ $t('clientmanage.addDialog.specialPayout') }}
              </el-button>
            </template>
          </el-table-column>
          <!--                    <el-table-column prop="type" :label="$t('orders.label.table.dispensing')" width="120px"-->
          <!--                        v-if="permission.indexOf('payout:payoutTransfer') != -1">-->
          <!--                        <template slot-scope="{ row }"-->
          <!--                            v-if="row.orderStatus == 0 && row.type == 1 && row.otpStatus == 0">-->
          <!--                            <el-row style="margin-bottom: 3px" v-for="item in payoutBankList" :key="item.id">-->
          <!--                                <el-button type="warning" size="mini" @click="requestOtp(row.id, item.bankCode)">{{-->
          <!--                                    item.bankCode }}{{ $t('orders.label.table.dispensing') }}-->
          <!--                                </el-button>-->
          <!--                            </el-row>-->
          <!--                        </template>-->
          <!--                    </el-table-column>-->
          <!--                    <el-table-column label="OTP" width="200px" v-if="permission.indexOf('payout:payoutOtp') > -1">-->
          <!--                        <template slot-scope="{ row }" v-if="-->
          <!--                row.accountBankCode && row.transferInfo && row.orderStatus == 0 && row.type == 1-->
          <!--              ">-->
          <!--                            <img v-if="-->
          <!--                  (row.transferInfo && row.accountBankCode == 'MB') || row.accountBankCode == 'MSB'-->
          <!--                " :src="row.transferInfo" style="width: 100px; float: left" />-->
          <!--                            <p v-else-if="row.transferInfo && row.transferInfo.length > 0"-->
          <!--                                style="color: red; text-align: left">-->
          <!--                                {{ $t('userTransaction.label.no') }}: <span>{{ row.transferInfo }}</span>-->
          <!--                            </p>-->
          <!--                            <el-input size="mini" v-model="row.otp"-->
          <!--                                style="width: 60%; float: left; margin-right: 5px"></el-input>-->
          <!--                            <el-button size="mini" type="danger" @click="submitRowOtp(row)" style="float: left">{{-->
          <!--                                $t('btns.submit')-->
          <!--                                }}</el-button>-->
          <!--                        </template>-->
          <!--                    </el-table-column>-->
          <el-table-column
            :label="$t('withdraw.label.applyTime')"
            prop="applyTime"
          ></el-table-column>
          <el-table-column
            :label="$t('withdraw.label.paymentBank')"
            prop="accountBankCode"
            v-if="!info.userType"
          ></el-table-column>
          <el-table-column
            :label="$t('withdraw.label.paymentName')"
            prop="accountName"
            v-if="!info.userType"
          ></el-table-column>
          <el-table-column
            width="200px"
            :label="$t('merchantIp.label.action')"
            v-if="
              (permission.indexOf('merchant:payout:callback') > -1 ||
                permission.indexOf('payout reject') != -1 ||
                permission.indexOf('payout:manual:makeup') != -1) &&
              !info.userType
            "
          >
            <template slot-scope="scope">
               <!----------------------------------- 二维码  --------------------------------->
              <el-button type="primary" size="mini"  v-if="scope.row.orderStatus == 88" @click="showQRFn(scope.row)">{{$t('btns.qrCode')}}</el-button>
              <!----------------------------------- 回调 start --------------------------------->
              <el-popconfirm
                :ref="`popover-${scope.row.id}`"
                :key="`${scope.row.id}`"
                :title="$t('orders.tip.danger')"
                @confirm="getCallback(scope.row)"
              >
                <!-- 回调按钮:  订单状态只要是 1,2,88 并且回调状态是-1  就显示 -->
                <el-button
                  slot="reference"
                  type="primary"
                  v-if="
                    [1, 2, 88].indexOf(scope.row.orderStatus) != -1 &&
                    (scope.row.syncStatus == -1 || scope.row.syncStatus == 0)
                  "
                  size="mini"
                  >{{ $t('btns.callback') }}
                </el-button>
              </el-popconfirm>
              <!----------------------------------- 回调 ended --------------------------------->
              <!-----------------------------------scope.row.type == 1 && 拒绝 start --------------------------------->
              <el-popconfirm
                :ref="`popover-${scope.row.id + 2}`"
                :key="`${scope.row.id + 2}`"
                :title="$t('orders.tip.danger')"
                @confirm="rejectOrder(scope.row)"
              >
                <el-button
                  slot="reference"
                  type="danger"
                  v-if="
                    [1, 2, 88, 6].indexOf(scope.row.orderStatus) == -1 && scope.row.otpStatus == 0
                  "
                  size="mini"
                  >{{ $t('status.error3') }}
                </el-button>
              </el-popconfirm>
              <!----------------------------------- 拒绝 ended --------------------------------->
              <!-----------------------------------scope.row.type == 1 &&  手动补单 start --------------------------------->
              <el-popconfirm
                :ref="`popover-${scope.row.id + 3}`"
                :key="`${scope.row.id + 3}`"
                :title="$t('orders.tip.danger')"
                @confirm="manualOrder(scope.row)"
              >
                <el-button
                  slot="reference"
                  type="success"
                  v-if="[1, 2, 88].indexOf(scope.row.orderStatus) == -1"
                  size="mini"
                  >{{ $t('btns.manual') }}
                </el-button>
              </el-popconfirm>
              <!----------------------------------- 手动补单 ended --------------------------------->
              <!-----------------------------------scope.row.type == 1 &&  手动补单 start --------------------------------->
                <el-button
                slot="reference"
                type="success"
               v-if="(scope.row.attribute3&&scope.row.attribute3!=='')&&(scope.row.orderStatus===1||(scope.row.orderStatus===88&&userType!==0))"
                size="mini"
                @click="gotoBankHandler(scope.row)"
                >{{ $t('rolemanager.View') }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('merchantIp.label.operator')"
            prop="operatorName"
             v-if="!info.userType"
          ></el-table-column>
          <el-table-column
            v-if="!info.userType"
            :label="$t('device.remark')"
            prop="description"
            width="250"
          ></el-table-column>
          <el-table-column
            :label="$t('orders.label.table.payoutTime')"
            prop="payTime"
          ></el-table-column>
          <el-table-column
            :label="$t('withdraw.label.notifyTime')"
            prop="notifyTime"
          ></el-table-column>
          <el-table-column
            :label="$t('device.channelType')"
            prop="attribute4"
             width="120"
          ></el-table-column>
        </el-table>
      </el-row>
      <v-pagination
        v-model="form"
        :sizes="[20, 50, 100, 500]"
        :size="form.size"
        :total="payoutOrderInfo.rows"
        @update="getMerchantPayoutOrderList"
      />
    </el-card>
    <el-dialog
      label="OTP"
      width="600px"
      height="400px"
      :visible.sync="showOtpDialog"
      :close-on-click-modal="false"
      v-loading="otpLoading"
      :title="optDialogTitle"
    >
      <el-card>
        <img
          v-if="
            (optInfo.transferInfo && optInfo.accountBankCode == 'MB') ||
            optInfo.accountBankCode == 'MSB'
          "
          :src="optInfo.transferInfo"
          style="width: 200px; margin: 0 auto; display: block"
        />
        <p v-else-if="optInfo.transferInfo && optInfo.transferInfo.length > 0" style="color: red">
          {{ $t('userTransaction.label.no') }}: <span>{{ optInfo.transferInfo }}</span>
        </p>
        <el-form ref="optForm" :model="optForm" :inline="true" style="padding: 40px 0">
          <el-form-item label="OTP" :rules="otpRules">
            <el-input v-model.trim="optForm.opt" size="mini"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="submitOtp">{{
              $t('btns.confirm')
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-dialog>
    <el-dialog :visible.sync="showQR" @close="closeQr" width="500px"  :style="{ left: '70%', transform: 'translate(-10%, 0)' }">
      <div class="qr-code-box">
        <img :src="qrCodeData.qrcode" />
        <div class="input-box">
          <el-input v-model.trim="amount" @input="handleInput"   @focus="handleFocus"    :placeholder="$t('accountmanager.inputtext')" clearable />
          <el-button type="primary" :disabled="!amount" size="mini" @click="updateQrCode(modalData.systemOrderNo, amount)">{{ $t('orders.label.table.submitAmount') }}</el-button>
        </div>
        <div class="row">{{ $t('withdraw.label.bankNo') }}：{{ modalData.cardNumber }}</div>
        <div class="row">{{ $t('withdraw.label.bankCode') }}：{{ modalData.bankCode }}</div>
        <div class="row">{{ $t('withdraw.label.receiver') }}：{{ modalData.beneficiaryName }}</div>
        <div class="row">{{ $t('withdraw.orderDescription') }}：{{ qrCodeData.attribute5 }}</div>
        <div class="row">{{ $t('channelTest.label.amount') }}：{{ modalData.amount | toAmountotal }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import merchantApi from '@/api/merchant';
import dayjs from 'dayjs';
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { isNumber, minLenNumber } from '../../../utils/validate';
import RangeDatePicker from '../../cuscom/range-date-picker.vue';
import base from '@/mixin/base.js';
import channelApi from "@/api/channel";
import { getPageCode, openCenteredWindow } from "@/utils"
export default {
  mixins: [base],
  name: 'Clientmanage',
  components: { RangeDatePicker },
  data() {
    return {
      channelTypeArray:[],
      select: [],
      searchLoading:false,
      payoutOrderInfo: {},
      tableLoading: false,
      tableData: [],
      refresh: true,
      refInterval: null,
      formTime: [],
      payoutCountInfo: {},
      form: {
        no: 1,
        size: 100,
        query: {
          merchantNo: '',
          systemOrderNo: '',
          orderNo: '',
          orderStatus: '',
          syncStatus: '',
          payoutTimeStart: '',
          payoutTimeEnd: '',
          submitTimeStart: '',
          submitTimeEnd: '',
          accountName: '',
          amountStart: '',
          amountEnd: '',
          tripleChannelType:'',
          paymentType:'',//代付类型
          accountNumber:'',
          accountBankCode: ''
        }
      },
      payoutBankList: [],
      optInfo: {},
      optForm: {
        opt: ''
      },
      optDialogTitle: '',
      showOtpDialog: false,
      otpLoading: false,
      otpRules: [
        {
          required: true,
          validator: (rules, value, cb) => {
            if (!isNumber(value) || !minLenNumber(6, 8)) {
              cb(new Error(this.$t('withdraw.rules.loginName.required').toString()));
            } else {
              cb();
            }
          },
          trigger: 'blur'
        }
      ],
      showQR: false, // 显示二维码
      modalData: {},
      amount: '',
      qrCodeData:{
        attribute5: '',
        qrcode: '',
      }
    };
  },
  computed: {
    ...mapState({
      info: ({ user }) => user.info
    }),
    ...mapGetters(['permission']),
    userType() {
      return this.$store.state.user.userType;
    },
    notify() {
      return this.$t('withdraw.label.asyncStatus');
    },
    btnsTime() {
      return this.$t('orders.btns');
    },
    orderStatusCode() {
      return {
        0: this.$t('status.doing2'),
        1: this.$t('status.success5'),
        2: this.$t('status.error'),
        6: this.$t('status.doing'),
        88: this.userType !== 0?this.$t('status.success5'):this.$t('status.doing88')
      };
    },
    paymentType() {
      return [
        {
          value: 0,
          label: this.$t('withdraw.label.payoutType1')
        },
        {
          value: 1,
          label: this.$t('withdraw.label.payoutType2')
        },
      ]
    }
  },
  created() {},
  mounted() {
    this.getPayoutBankList();
    this.getMerchantPayoutOrderList();
    this.refTableData();
    this.channelType();
  },
  beforeDestroy() {
    this.refInterval && clearInterval(this.refInterval);
  },
  methods: {
    gotoBankHandler(row){
      const baseUrl='https://asiapi1.xkiosx.xyz/'
      const url={
        ACB:'ACB_Other.html',
        VCB:'Vietcombank.html',
        TIMO:'Timo.html',
      }
      if (['ACB','TIMO'].includes(row.accountBankCode)) {
        window.open(`${baseUrl}${url[row.accountBankCode]}?data=${row.attribute3}`,'_bank')
        return
      }

     const pageCode = getPageCode(row.accountBankCode,row.bankCode)
     openCenteredWindow({
        pageCode: pageCode.page,
        data: row.attribute3,
        width: pageCode.width,
        height: pageCode.height,
        bankCode: row.bankCode
      })
    },
    handleSearch(){
      this.searchLoading = true;
      this.getMerchantPayoutOrderList();
    },
    tableRowClassName({ row, rowIndex }) {
      const orderStatus = row.orderStatus;
      switch (orderStatus) {
        case 0:
          return 'tab-col-blue';
        case 1:
          return 'tab-col-green';
        case 2:
          return 'tab-col-lightcoral';
        case 6:
          return 'tab-col-pink';
        case 88:
          return this.userType !== 0 ? 'tab-col-green' : 'tab-col-red'; //'tab-col-red'
        default:
          return '';
      }
    },
    handleShowDateTime(val) {
      this.formTime = val;
      [this.form.query.submitTimeStart, this.form.query.submitTimeEnd] = val;
      console.log('这哥们广告发士大夫。。。', val);
    },
    handleShowPayOutTime(val) {
      [this.form.query.payoutTimeStart, this.form.query.payoutTimeEnd] = val;
    },
    async getPayoutBankList() {
      const { data } = await merchantApi.getPayoutBanks(this.form);
      if (data.code == 200) {
        if (data.data.list && data.data.list.length > 0) {
          // data.data.list.map((item) => {
          //   if (item.status == 1) {
          //     this.payoutBankList.push(item);
          //   }
          // });
          this.payoutBankList = data.data.list.filter((item) => item.status === 1);
          this.payoutBankList = this.unique(this.payoutBankList, 'bankCode');
        }
      } else {
        this.$message.error(data.msg || this.$t('status.error'));
      }
    },
    async getCallback(row) {
      const Code = await this.promptGoogleCode();
      if (!Code) return;
      const { data, config } = await merchantApi.getCallback(`${row.systemOrderNo}/${Code.value}`);
      localStorage.setItem(`${this.info.userName}-${Date.now()}`, config.url);
      if (data) {
        if (data.code === 200) {
          this.$message.success(this.$t('status.success'));
          this.getMerchantPayoutOrderList();
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    async manualOrder(row) {
      // const Code = await this.promptGoogleCode();
      // if (!Code) return;
      const Code = '123456'
      const { data, config } = await merchantApi.manualOrder(`${row.systemOrderNo}/${Code}`);
      if (data) {
        if (data.code === 200) {
          this.$message.success(this.$t('status.success'));
          this.getMerchantPayoutOrderList();
        } else {
          this.$message.error(data.msg);
        }
      }
      localStorage.setItem(`${this.info.userName}-${Date.now()}`, config.url);
    },
    async rejectOrder(row) {
      const Code = await this.promptGoogleCode();
      if (!Code) return;
      const { data } = await merchantApi.rejectOrder(`${row.systemOrderNo}/${Code.value}`);
      if (data) {
        if (data.code === 200) {
          this.$message.success(this.$t('status.success'));
          this.getMerchantPayoutOrderList();
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    refTableData() {
      if (this.refresh) {
        this.refInterval = setInterval(() => {
          this.getMerchantPayoutOrderList(true);
        }, 1000 * 60);
      } else {
        clearInterval(this.refInterval);
      }
    },
    async getMerchantPayoutOrderList(isAuto = false) {
      const [submitTimeStart, submitTimeEnd] = this.formTime;
      this.form.query.submitTimeStart = submitTimeStart;
      this.form.query.submitTimeEnd = submitTimeEnd;
      console.log(submitTimeStart, ' ADSFASDFASDF   ', submitTimeEnd);

      // if(submitTimeStart&&dayjs(submitTimeStart).month()!==dayjs().month()){
      //   console.log('这里找你下阿斯蒂芬。。。。。。。')
      //     return;
      // }
      // if (isAuto){
      //   this.form.query.submitTimeStart = dayjs().format('YYYY-MM-DD 00:00:00');
      //   this.form.query.submitTimeEnd = dayjs().format('YYYY-MM-DD HH:mm:ss');
      // }
      this.tableLoading = true;
      console.log('我这拉伸。。。有故意的问题。。。', this.form.query);
      const { data } = await merchantApi.getPayoutOrders({ data: this.form });
      if (data && data.code == 200) {
        this.payoutOrderInfo = data.data;
        this.tableData = data.data.list;
        this.getPayoutCountInfo();
        this.tableLoading = false;
      } else {
        this.tableLoading = false;
        this.$message.error(data.msg || this.$t('status.error'));
      }
      this.searchLoading = false;
    },
    getPayoutCountInfo() {
      const [submitTimeStart, submitTimeEnd] = this.formTime;
      this.form.query.submitTimeStart = submitTimeStart;
      this.form.query.submitTimeEnd = submitTimeEnd;
      console.log('d嗯行是啊速度放缓士大夫这里的问题呢。。。', this.formTime);
      const params = {
        submitTimeStart: submitTimeStart,
        submitTimeEnd: submitTimeEnd,
        merchantNo: this.form.query.merchantNo,
        systemOrderNo: this.form.query.systemOrderNo,
        orderNo: this.form.query.orderNo,
        orderStatus: this.form.query.orderStatus,
        syncStatus: this.form.query.syncStatus,
        payoutTimeStart: this.form.query.payoutTimeStart,
        payoutTimeEnd: this.form.query.payoutTimeEnd
      };
      merchantApi.getPayoutCount({ data: params }).then((res) => {
        if (res.data.code == 200) {
          this.payoutCountInfo = res.data.data;
        }
      });
    },
    async handleExport() {
      const [submitTimeStart, submitTimeEnd] = this.formTime;
      this.form.query.submitTimeStart = submitTimeStart;
      this.form.query.submitTimeEnd = submitTimeEnd;
      const { data } = await merchantApi.exportPayoutOrders({ data: this.form.query });
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-Payout-Orders-${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(data.msg || this.$t('status.error'));
      }
    },
    async requestAutoPayOut(orderId) {
      const Code = await this.promptGoogleCode();
      if (!Code) return;
      this.tableLoading = true;
      const { data } = await merchantApi.setAutoPayOut({ id: `${orderId}/${Code.value}` });
      if (data.code == 200) {
        // this.optInfo = data.data;
        this.tableLoading = false;
        this.$message.success(this.$t('status.success').toString());
        this.getMerchantPayoutOrderList();
      } else {
        this.$message.error(data.msg || this.$t('status.error'));
        this.tableLoading = false;
      }
    },
    async requestOtp(orderId, bankCode) {
      this.tableLoading = true;
      const { data } = await merchantApi.requestOtp({ id: orderId, bankCode: bankCode });
      if (data.code == 200) {
        this.optInfo = data.data;
        this.tableLoading = false;
        this.$message.success(this.$t('status.success').toString());
        this.getMerchantPayoutOrderList();
        // this.optDialogTitle = `${bankCode}${this.$t("orders.label.table.dispensing")}`;
        // this.showOtpDialog = true;
      } else {
        this.$message.error(data.msg || this.$t('status.error'));
        this.tableLoading = false;
      }
    },
    submitRowOtp(row) {
      if (!this.optInfo || !row.otp || row.otp.length < 6) return;
      this.tableLoading = true;
      this.handleSubmitOtp(row.otp);
    },
    submitOtp() {
      this.$refs.optForm.validate((valid) => {
        if (valid) {
          this.otpLoading = true;
          this.handleSubmitOtp();
        }
      });
    },
    handleSubmitOtp(otp) {
      const params = {
        id: this.optInfo.id,
        bankCode: this.optInfo.accountBankCode,
        otp: otp || this.optForm.opt
      };
      merchantApi.submitOtp(params).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(this.$t('status.success'));
          this.showOtpDialog = false;
          this.otpLoading = false;
          this.tableLoading = false;
          this.getMerchantPayoutOrderList();
        } else {
          this.$message.error(res.data.msg || this.$t('status.error'));
          this.showOtpDialog = false;
          this.otpLoading = false;
          this.tableLoading = false;
        }
      });
    },
    handleEmpty() {
      (this.form.query = {
        merchantNo: '',
        systemOrderNo: '',
        orderNo: '',
        orderStatus: '',
        syncStatus: ''
      }),
        (this.form.no = 1);
      this.form.current = 1;
      this.$refs.datePick.handleTime();
      this.$refs.payOutDatePick.handleTime();
    },
    handleTime(type = '') {
      const date = new Date();
      // 当天零点
      const zeroTime = new Date(date.toLocaleDateString()).getTime();
      // 当年
      const nowY = date.getFullYear();
      // 当月
      const nowM = date.getMonth();
      // 当月第一天
      const firstDayNow = new Date(nowY, nowM, 1);
      // 上月第一天
      const firstDayNow1 = new Date(nowY, nowM - 1, 1);
      let start = '';
      let end = '';
      let tempDay = '';
      switch (type) {
        case 'today':
          start = this.timestamp(zeroTime);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case 'yesterday':
          if (this.form.query.payoutTimeStart) {
            tempDay = new Date(
              new Date(this.form.query.payoutTimeStart).toLocaleDateString()
            ).getTime();
            start = this.timestamp(tempDay - 60 * 60 * 24 * 1000);
            end = this.timestamp(tempDay - 1);
          } else {
            start = this.timestamp(zeroTime - 60 * 60 * 24 * 1000);
            end = this.timestamp(new Date(new Date().toLocaleDateString()).getTime() - 1);
          }
          break;
        case 'month':
          start = this.timestamp(firstDayNow);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case 'lastMonth':
          start = this.timestamp(firstDayNow1);
          end = this.timestamp(new Date(firstDayNow).getTime() - 1);
          break;
        default:
          break;
      }
      console.log(
        '这类似按时地方按时地方。 。。。',
        start,
        end
      )((this.form.query.payoutTimeStart = start)),
        (this.form.query.payoutTimeEnd = end);
    },
    timestamp(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
    unique(arr, val) {
      const res = new Map();
      return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1));
    },

    rowKey(row) {
        return row.id;
      },

    handleSelectionChange(list) {
      console.log(list);
      this.select = list;
    },

    // 批量补单
    async allOlder() {
      if (this.select.length == 0) {
        this.$message({
          type: 'info',
          message:this.$t('status.choose')
        });
        return;
      }

      this.$confirm(this.$t('status.worring'), this.$t('status.tip'), {
        confirmButtonText: this.$t('status.confor'),
        cancelButtonText: this.$t('status.Cancel'),
        type: 'warning'
      })
        .then(async () => {
          let ids = this.select.map((it) => it.systemOrderNo);
          let params = {
            patchGoogleCode:123456,
            systemOrderNos: ids
          };
          this.tableLoading = true;
          const { data } = await merchantApi.allMakeOrder(params);
          if (data.code == 200) {
            this.$message.success(data.msg);
            this.tableLoading = false;
            this.$message({
            type: 'success',
            message: '批量补单成功!'
          });
          this.getMerchantPayoutOrderList();
          } else {
            this.$message.error(data.msg);
            this.tableLoading = false;
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取批量补单'
          });
        });
    },

    //三方通道类型
    async channelType() {
        const params = {
          no: 1,
          size: 100,
          current:1,
        }
        const { data } = await channelApi.getChannelPage({ data: params });
        if (data && data.code == 200) {
          if(data.data.list) {
            let results = data.data.list.filter(item => item.channelCode =='payout');
             this.channelTypeArray = []
              results.forEach(result => {
                  result.tripleChannelList.forEach(tripleChannelItem => {
                    this.channelTypeArray.push(tripleChannelItem.tripleChannel)
                  });
                });
          }else {
            this.$message.error(data.msg);
          }
        }
      },

    showQRFn(row) {
      merchantApi.getQrCode2({systemOrderNo: row.systemOrderNo}).then(res => {
        this.qrCodeData = res.data.data
      })
      this.modalData = row
      this.showQR = true
    },
   
    updateQrCode(systemOrderNo, num) {
      const amount = num.replace(/,/g, ''); // 移除逗号
      merchantApi.getQrCode2({systemOrderNo, amount}).then(res => {
        this.qrCodeData = res.data.data
      })
    },
    closeQr() {
      this.showQR = false
      this.amount = ''
    },
     // 聚焦时移除格式化
     handleFocus() {
      this.amount = this.amount.replace(/,/g, '');
    },

    // 格式化金额
    formatAmount() {
      const numberValue = parseInt(this.amount, 10);
      if (!isNaN(numberValue)) {
          // 使用本地化的格式化规则，确保使用逗号作为千位分隔符
          this.amount = numberValue.toLocaleString('en-US');
        }
      },

    // 输入停止时格式化金额
    handleInput() {
      // 使用正则表达式过滤掉非数字字符
      this.amount = this.amount.replace(/[^\d]/g, '');
       // 清除之前的防抖计时器
       if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
        // 设置新的防抖计时器，在 500 毫秒后执行格式化
        this.debounceTimeout = setTimeout(() => {
        this.formatAmount();
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
        background: rgba(0, 0, 0, 0.2);
  padding-right: 40px;

  .list-table {
    display: flex;
    list-style: none;

    li {
      display: flex;
      list-style: none;

      .label {
        font-style: normal;
      }

      .value {
        display: flex;
        list-style: none;
      }
    }

    li:nth-child(n + 2) {
      margin-left: 30px;
    }
  }

  .btn-table {
    margin-left: auto;
  }
}

.box-card,
.table,
.pag {
  margin-top: 20px;
}

.el-col .el-button:nth-child(1),
.el-col .el-button:nth-child(2) {
  padding: 10px 14px;
}

/deep/ .el-switch__core {
  margin: 0 10px;
}
/deep/ .el-table .tab-col-blue {
  color: blue;
}

/deep/ .el-table .tab-col-green {
  color: green;
}
/deep/ .el-table .tab-col-red {
  color: red;
}
/deep/ .el-table .tab-col-lightcoral {
  color: lightcoral;
}
/deep/ .el-table .tab-col-pink {
    color: #E546F0;
}

.qr-code-box{
  img{
    width: 200px;
    height: 200px;
    display: block;
    margin: auto;
  }
  .input-box{
    display: flex;
    gap: 10px;
    margin: 10px 0;
  }
  .row{
    margin-top: 10px
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payout/orders/index.vue